// extracted by mini-css-extract-plugin
export default {"terms-of-use":"TermsOfUse_terms-of-use__EWvzk","contacts":"TermsOfUse_contacts__AS70I","header":"TermsOfUse_header__vV6RF"};